<template>
  <v-btn icon @click="downloadContract(item)" color="primary">
    <v-icon>mdi-download-circle</v-icon>
  </v-btn>
</template>

<script>
import {formatAddress, getImageAsBase64} from "@/assets/utils/common.utils";
import {colClients} from "@/assets/utils/firebase.utils";
import {doc, getDoc} from "firebase/firestore";

export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    async downloadContract(item) {
      try {
        this.$loader.show();
        if (item.customer_id && this.item.client == null) {
          let clientRef = doc(colClients, item.customer_id);
          item.client = (await getDoc(clientRef)).data();
        }
        let element = document.createElement("body");
        let html = `
        <style>
          p {
           margin-bottom:16px!important
          } 
          body {
          font-family: "Lato", sans-serif;
          }
          ol {
              padding-left:24px;
          }
          </style>`;
        html += item.agreement;
        if (item.digital_signature) {
          let image = await getImageAsBase64(item.digital_signature);
          html += `
        <br />
        <br />
        <strong>My Digital Signature</strong>
            <span style="display: block">
              <img src="${image}" width="300" height="80" />
            </span>
            <p style="color: #4a4a4a; font-size: 14px; font-weight: bold;margin-bottom:16px">
              ${item.customer_name},${item.signedAt}
            </p>
            <div style="background: #fffcd9; padding: 20px;font-size:0.875rem;  break-inside: avoid;  page-break-inside: avoid;  display: block;">
              <b>Digital Signature:</b> <br />
              <br />
              Client Name: ${item.customer_name} <br />
        `;
          if (item.client) {
            html += `Email: ${item.client.email}<br />
  
                Phone: ${item.client.mobile} <br />
  
                Address: ${formatAddress(item.client)} <br />`;
          }
          html += `Verified receipt and agreed:
            ${item.verified_and_agreed_on == true ? "yes" : "no"} <br />

            Timestamp: ${item.timestamp}<br />

            IP Address: ${item.ip_address}
            <br />
            <br />
            *<b>Digital Signatures</b>: In 2000, the U.S. Electronic Signatures
            in Global and National Commerce (ESIGN) Act established electronic
            records and signatures as legally binding, having the same legal
            effects as traditional paper documents and handwritten signatures.
            Read more at the FTC web site:
            <a
              style="color: #589ee4"
              href="http://www.ftc.gov/os/2001/06/esign7.htm"
              target="_blank"
              >http://www.ftc.gov/os/2001/06/esign7.htm</a
            >
          </div>          
          `;
        }
        element.innerHTML = html;
        const options = {
          filename: `${item.customer_name}.pdf`,
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { scale: 2 },
          margin: 0.2083,
          useCORS: true,
          jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
        };
        // eslint-disable-next-line no-undef
        await html2pdf().set(options).from(element).save();
        this.$loader.hide();
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style></style>
